import React, { FunctionComponent } from 'react';
import { Translate } from 'react-localize-redux';
import moment from 'moment';

// Types
import CatalogFilter from '@common/types/catalog/catalog-filter-type';

// Components
import Grid from '@components/basics/grid';
import Typography from '@components/basics/typography';
import DateIcon from '@components/basics/icons/date-icon';
import DatepickerWithFilters from '@components/form/datepicker-w-filters';

// Controllers
import { GenericDropdownBuilder } from '@webapp/controllers/form/dropdown';

import { IconWrapper, Wrapper } from './components';

const DropdownCtrl = GenericDropdownBuilder();

interface DateAddedFilterProps {
  className?: string;
  filterOption: CatalogFilter;
  setFilterOption: React.Dispatch<React.SetStateAction<CatalogFilter>>;
}

const ONE_DAY_OFFSET = 24 * 60 * 60 * 1000;

const FILTERS = [
  { label: 'Month', value: 30 * ONE_DAY_OFFSET },
  { label: 'Year', value: 365 * ONE_DAY_OFFSET },
  { label: 'All-time', value: 365 * 10 * ONE_DAY_OFFSET },
];

const DateAddedFilter: FunctionComponent<DateAddedFilterProps> = ({
  className,
  filterOption,
  setFilterOption,
}) => {
  const [hasDateChanges, setHasDateChanges] = React.useState(false);

  const getTitle = () => {
    if (filterOption.dateAdded) {
      return `
      ${moment(filterOption.dateAdded.startDate).format('MMM DD YYYY')}
        -
      ${moment(filterOption.dateAdded.endDate).format('MMM DD YYYY')}`;
    }

    return <Translate id="CATALOG.MENU.FILTER.SELECT_DATE.LABEL" />;
  };

  React.useEffect(() => {
    if (!filterOption.dateAdded) {
      setHasDateChanges(false);
    }
  }, [filterOption]);

  return (
    <Grid gap={20} className={className || ''}>
      <Typography weight="700">
        <Translate id="CATALOG.MENU.FILTER.DATE_ADDED.TITLE" />
      </Typography>
      <Wrapper
        justifyContent="space-between"
        alignItems="center"
        flexDirection="column"
        gap={5}
      >
        <DropdownCtrl
          title={getTitle()}
          isGrey
          hasPillShape
          disabled={!!filterOption.releaseDate}
          hasChanges={hasDateChanges}
          customIcon={
            <IconWrapper className={hasDateChanges ? 'has-changes' : ''}>
              <DateIcon isInvertedTheme={hasDateChanges} />
            </IconWrapper>
          }
        >
          <DatepickerWithFilters
            filters={FILTERS}
            hasChanges={hasDateChanges}
            onChange={(start, end) => {
              if (start && end) {
                setFilterOption({
                  ...filterOption,
                  ...{
                    dateAdded: {
                      startDate: new Date(start.toDate()),
                      endDate: new Date(end.toDate()),
                    },
                  },
                });
                setHasDateChanges(true);
              }
            }}
          />
        </DropdownCtrl>
      </Wrapper>
    </Grid>
  );
};

export default DateAddedFilter;
